<div class="container-fluid section-card form p-0">
  <div class="text-left pt-3 ps-3">
    <h3 class="profile-title">Horarios</h3>
    <span class="sub-title mt-2 mb-3"
      >Estos son los horarios del prestador</span
      >
    </div>
    <mat-tab-group>
      <mat-tab label="Horarios">
        <div>
          @if (!edit) {
            <ul class="list-group cont-scroller">
              @for (wd of supplierWorkingDays; track wd) {
                <li class="mb-1 ps-3">
                  <div class="row my-2 mx-0 align-items-center">
                    <div class="day-desc col-2">
                      <span>{{ getDayDescription(wd.day) }}</span>
                    </div>
                    <div class="col-8 hour-desc mt-0">
                      @if (wd.hoursDisplay == 'Sin horario') {
                        <div
                          class="float-left"
                          >
                          <span>{{ wd.hoursDisplay }}</span>
                        </div>
                      }
                      @if (wd.hoursDisplay != 'Sin horario') {
                        <div
                          class="float-left d-flex"
                          >
                          @for (hour of wd.workingHours; track hour; let i = $index) {
                            <div
                              class="hours-complete"
                              >
                              <span [ngClass]="i > 0 ? 'ms-2' : ''"
                                >{{ formatDate(hour.startHour) }} -
                                {{ formatDate(hour.endHour) }}</span
                                >
                                <button
                                  class="delete-work-hours-btn"
                                  (click)="deleteHour(wd.id, hour.id)"
                                  >
                                  <mat-icon>close</mat-icon>
                                </button>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="line mt-2"></div>
                  </li>
                }
              </ul>
            }
            <div class="line mt-0"></div>
            @if (!edit) {
              <div class="footer d-flex justify-content-end">
                <button
                  id="addButton"
                  class="mt-3 mb-3 me-3 no-back-color"
                  (click)="editHour()"
                  >
                  Editar horarios
                </button>
              </div>
            }
            <div>
              @if (edit) {
                <div>
                  <ul class="list-group cont-scroller">
                    @for (wd of supplierWorkingDays; track wd; let dayIndex = $index) {
                      <li
                        class="mb-1 ps-3"
                        >
                        <div class="row my-2 mx-0">
                          <div class="w-10">
                            <mat-checkbox
                              [checked]="validateCheck(wd.day)"
                              value="{{ wd.day }}"
                              (change)="onCheckChange($event)"
                              >
                              {{ getDayDescription(wd.day) }}</mat-checkbox
                              >
                            </div>
                            <div class="hour-desc w-75 my-auto">
                              @if (wd.hoursDisplay == 'Sin horario') {
                                <div
                                  class="float-left d-flex me-2"
                                  >
                                  <span>{{ wd.hoursDisplay }}</span>
                                  @if (validateCheck(wd.day)) {
                                    <div class="ms-2">
                                      <input
                                        type="time"
                                        (change)="timeChanged(wd.fromHour, dayIndex, true)"
                                        [(ngModel)]="wd.fromHour"
                                        step="300"
                                        required
                                        />
                                        -
                                        <input
                                          type="time"
                                          [(ngModel)]="wd.toHour"
                                          step="300"
                                          (change)="validateToHour(dayIndex)"
                                          [min]="minToHour"
                                          required
                                          />
                                        </div>
                                      }
                                    </div>
                                  }
                                  @if (wd.hoursDisplay != 'Sin horario') {
                                    <div
                                      class="float-left d-flex"
                                      >
                                      @for (hour of wd.workingHours; track hour; let i = $index) {
                                        <div
                                          class="me-2 pb-2"
                                          >
                                          <span [ngClass]="i > 0 ? 'ms-2' : ''"
                                            >{{ formatDate(hour.startHour) }} -
                                            {{ formatDate(hour.endHour) }}</span
                                            >
                                            <button
                                              class="delete-work-hours-btn"
                                              (click)="deleteHour(wd.id, hour.id)"
                                              >
                                              <mat-icon>close</mat-icon>
                                            </button>
                                          </div>
                                        }
                                        @if (validateCheck(wd.day)) {
                                          <div>
                                            <input
                                              type="time"
                                              (change)="timeChanged(wd.fromHour, dayIndex, true)"
                                              [(ngModel)]="wd.fromHour"
                                              step="300"
                                              required
                                              />
                                              -
                                              <input
                                                type="time"
                                                [(ngModel)]="wd.toHour"
                                                step="300"
                                                (change)="validateToHour(dayIndex)"
                                                [min]="minToHour"
                                                required
                                                />
                                              </div>
                                            }
                                          </div>
                                        }
                                      </div>
                                    </div>
                                    @if (wd.errorMessage) {
                                      <div class="error-message ps-3">
                                        {{ wd.errorMessage }}
                                      </div>
                                    }
                                    <div class="line mt-0"></div>
                                  </li>
                                }
                              </ul>
                              <div class="line mt-0"></div>
                              <div class="footer d-flex justify-content-end">
                                <button
                                  class="mt-3 mb-3 me-3 no-back-color"
                                  type="button"
                                  (click)="onSubmit()"
                                  [disabled]="selectedDays.length == 0"
                                  >
                                  <span>Actualizar horarios</span>
                                </button>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </mat-tab>
                    <mat-tab label="Excepciones" [disabled]="supplierWorkingDays.length == 0">
                      <div
                        class="modal-exception-days d-flex align-items-center justify-content-center w-100"
                        [ngClass]="{ expanded: showExceptionDaysCalendar }"
                        >
                        @if (showExceptionDaysCalendar) {
                          <div class="modal-container w-100">
                            <form
                              [formGroup]="scheduleExceptionForm"
                              autocomplete="off"
                              class="form-range-dates"
                              >
                              <div class="row pt-3">
                                <div class="range-dates-modal my-0">
                                  <h3>Seleccione la/s fecha/s no laborales</h3>
                                </div>
                                <app-range-dates
                                  (sendDates)="setException($event)"
                                  (clickOutside)="closeModal()"
                                ></app-range-dates>
                              </div>
                              <div class="row buttons-footer me-3">
                                <button
                                  class="ind-button-lite float-right"
                                  (click)="closeModal()"
                                  >
                                  <span>Cancelar</span>
                                </button>
                                <button
                                  class="ind-button float-right"
                                  (click)="saveExceptionDays()"
                                  >
                                  <span>Guardar</span>
                                </button>
                              </div>
                            </form>
                          </div>
                        }
                      </div>
                      <mat-tab-group animationDuration="0ms">
                        @for (group of exceptionGroupsByMonth | keyvalue; track group) {
                          <mat-tab
                            label="{{ getTabDesc(group.key) }}"
                            >
                            @for (exception of group.value; track exception) {
                              <div
                                class="col exceptionItem d-flex mb-2 mt-3 ms-3"
                                >
                                <div class="exceptionDate">
                                  <span>{{ getDate(exception.value.day) }}</span>
                                </div>
                                <div class="exceptionDateDelete">
                                  <mat-icon
                                    title="Eliminar excepción"
                                    class="delete-icon"
                                    (click)="deleteException(exception.value.id)"
                                    tabindex="0"
                                    (keydown)="onElementKeydown($event, exception.value.id)"
                                    >
                                    delete_forever
                                  </mat-icon>
                                </div>
                              </div>
                            }
                          </mat-tab>
                        }
                      </mat-tab-group>
                      <div class="line mt-0"></div>
                      <div class="footer d-flex justify-content-end">
                        <button class="mt-3 mb-3 me-3 no-back-color" (click)="openModal()">
                          <span>Agregar excepción</span>
                        </button>
                      </div>
                    </mat-tab>
                  </mat-tab-group>
                </div>
